{
  "deselectedItem": "{item} non selezionato.",
  "longPressToSelect": "Premi a lungo per passare alla modalità di selezione.",
  "select": "Seleziona",
  "selectedAll": "Tutti gli elementi selezionati.",
  "selectedCount": "{count, plural, =0 {Nessun elemento selezionato} one {# elemento selezionato} other {# elementi selezionati}}.",
  "selectedItem": "{item} selezionato."
}
